export class Referral {
    constructor() {
        this.id = null;
        this.tenantId = null;
        this.clientId = null;
        this.referenceBusinessId = null;
        this.referenceContactId = null;
        this.communityId = null;
        this.referralType = "";
        this.notes = "";
        this.deleted = false;
        this.createdBy = null;
        this.updatedBy = null;
        this.authorId = "";
        this.parentId = "";
        this.dateAdded = new Date();
        this.updatedAt = new Date();
        this.when = new Date();
    }
    static clone(source) {
        var theClone = new Referral();
        if (!source) {
            return theClone;
        }
        theClone.id = source.id;
        theClone.tenantId = source.tenantId;
        theClone.clientId = source.clientId;
        theClone.referenceBusinessId = source.referenceBusinessId;
        theClone.referenceContactId = source.referenceContactId;
        theClone.communityId = source.communityId;
        theClone.referralType = source.referralType;
        theClone.notes = source.notes;
        theClone.deleted = source.deleted;
        theClone.createdBy = source.createdBy;
        theClone.updatedBy = source.updatedBy;
        theClone.dateAdded = source.dateAdded;
        theClone.updatedAt = source.updatedAt;
        theClone.when = source.when;
        return theClone;
    }
    static load(source) {
        var theClone = new Referral();
        theClone.id = source.id;
        theClone.tenantId = source.tenantId;
        theClone.clientId = source.clientId;
        theClone.referenceBusinessId = source.referenceBusinessId;
        theClone.referenceContactId = source.referenceContactId;
        theClone.communityId = source.communityId;
        theClone.referralType = source.referralType;
        theClone.notes = source.notes;
        theClone.deleted = source.deleted;
        theClone.createdBy = source.createdBy;
        theClone.updatedBy = source.updatedBy;
        theClone.dateAdded = new Date(source.dateAdded);
        theClone.updatedAt = new Date(source.updatedAt);
        theClone.when = source.when ? new Date(source.when) : new Date();
        return theClone;
    }
}
//# sourceMappingURL=referral.js.map